import { put } from '@/services/put'

export function updateScoring(applicationId: string, body: Record<string, Record<string, Record<string, number>>>) {
  return put<Record<string, Record<string, Record<string, number>>>, undefined>(
    `/applications/${applicationId}/update-scoring`,
    body,
  )
}
